import axiosInstance from "../../../interceptor/intercetptor-inctence";

export const getPackageList = (formData) => {
    return axiosInstance.post(`api/package/list`, formData);
}

export const statusPackage = (id) => {
    return axiosInstance.post(`api/package/status/${id}`,{});
}

export const deletePackage = (id) => {
    return axiosInstance.post(`api/package/delete-package/${id}`,{});
}

export const addPackage = (formData) => {
    return axiosInstance.post(`api/package/create`,formData);
}

export const updatePackage = (id,formData) => {
    return axiosInstance.post(`api/package/update-package/${id}`,formData);
}

export const viewPackage = (id) => {
    return axiosInstance.post(`api/package/view-package/${id}`,{});
}

export const masterTest = () => {
    return axiosInstance.post(`api/test/master`,{});
}

export const masterTests = () => {
    return axiosInstance.post(`api/test/test-master`,{});
}
